export default {
    getMasterCategory: {
        url: "/api/v2/offline-assessment-categories",
        method: "get"
    },
    getMasterCategoryById: {
        url: "/api/v2/offline-assessment-categories/{category_id}",
        method: "get"
    },
    createMasterCategory: {
        url: "/api/v2/offline-assessment-categories/",
        method: "post"
    },
    updateMasterCategory: {
        url: "/api/v2/offline-assessment-categories/{category_id}",
        method: "put"
    },
    deleteMasterCategory: {
        url: "/api/v2/offline-assessment-categories/{category_id}",
        method: "delete"
    }
}
